module.exports = __webpack_public_path__ + "ly.svg?cd565debb96e242e746aa98813efc648";